import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
} from "@pimo/pimo-components/src/lib/pm-components";

import { TestAppState } from "../../../app";
import { getAllReportingItems } from "../../../helpers/pages-helpers/dashboard-plugin-helpers";

export function addDcSystemsCard(
  view: View<TestAppState, DragAndDropLayout>
): void {
  const dcSystemsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "dcSystemsDashboardComponent",
      labels: ["#dcSystems"],
      description: "Shows the number of DC Business Apps across all projects.",
      title: "DC Business Apps",
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  dcSystemsComponent.mapState(({ dashboard }) => ({
    title: "DC Business Apps",
    number: getAllReportingItems(dashboard).length,
  }));
}
